import { render } from "./QuotePriceBadge.vue?vue&type=template&id=2ee8d1cc&scoped=true&lang=pug"
import script from "./QuotePriceBadge.vue?vue&type=script&lang=js"
export * from "./QuotePriceBadge.vue?vue&type=script&lang=js"

import "./QuotePriceBadge.vue?vue&type=style&index=0&id=2ee8d1cc&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee8d1cc"]])

export default __exports__